import React from "react";
import "./ShoppingCardPopup.scss";
import * as shopActions from "../../../actions/shop";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";

const ShoppingCardPopup = (fl) => {
  const { t } = useTranslation();

  const firstVariation =
    fl.variations && fl.variations[0] ? fl.variations[0] : null;

  const secondVariation =
    fl.variations && fl.variations[1] ? fl.variations[1] : null;

  const tempItem = fl.cartTemp && fl.cartTemp[fl.id] ? fl.cartTemp[fl.id] : null;

  const amount1 = tempItem && tempItem.amount1 ? tempItem.amount1 : 0;
  const amount2 = tempItem && tempItem.amount2 ? tempItem.amount2 : 0;

  const canOrder = amount1 > 0 || amount2 > 0;

  const checkPlusTen = () => {
    if (!firstVariation) return false;

    const ten = Number(firstVariation.unitsInPackage);
    let secondCount = 0;

    if (tempItem && tempItem.amount2 && secondVariation) {
      secondCount = tempItem.amount2 * secondVariation.unitsInPackage;
    }

    if (!tempItem || !tempItem.amount1) {
      return fl.quantity - secondCount - ten >= 0;
    }

    return tempItem.amount1 * ten + ten + secondCount <= fl.quantity;
  };

  const checkPlusFifty = () => {
    if (!secondVariation) return false;

    const fifty = Number(secondVariation.unitsInPackage);
    let firstCount = 0;

    if (tempItem && tempItem.amount1 && firstVariation) {
      firstCount = tempItem.amount1 * firstVariation.unitsInPackage;
    }

    if (!tempItem || !tempItem.amount2) {
      return fl.quantity - firstCount - fifty >= 0;
    }

    return tempItem.amount2 * fifty + fifty + firstCount <= fl.quantity;
  };

  const checkMinusTen = () => {
    return !!(tempItem && tempItem.amount1 && tempItem.amount1 > 0);
  };

  const checkMinusFifty = () => {
    return !!(tempItem && tempItem.amount2 && tempItem.amount2 > 0);
  };

  return (
    <div className="fade-for-click2" onClick={fl.closeCart}>
      <div className="shopping-popup">
        <div className="shopping-popup__box" onClick={(e) => e.stopPropagation()}>
          <button
            type="button"
            className="close"
            onClick={fl.closeCart}
            aria-label={t("common.close")}
          >
            ×
          </button>

          <div className="shopping-popup__image-wrap">
            <img src={fl.photoLink} alt={fl.fullName} />

            {fl.specialOffer ? (
              <div className="shopping-popup__promo">
                {t("product.specialOffer")}
              </div>
            ) : null}
          </div>

          <div className="shopping-popup__content">
            <h2>{fl.fullName}</h2>

            <div className="shopping-popup__params">
              <div>
                <p>{t("product.length")}: {fl.height}</p>
                <p>{t("product.available")}: {fl.quantity}</p>
                <p>{t("product.quality")}: {fl.quality}</p>
              </div>

              <div>
                <p>{t("product.color")}: {fl.color}</p>
                <p>{t("product.supplier")}:</p>
                <p>{fl.grower}</p>
              </div>
            </div>

            <div className="shopping-popup__line" />

            <div
              className={
                secondVariation
                  ? "shopping-popup__counts"
                  : "shopping-popup__counts shopping-popup__counts--single"
              }
            >
              {firstVariation ? (
                <div className="shopping-popup__count-item">
                  <div className="shopping-popup__pack">
                    <span>x{firstVariation.unitsInPackage}</span>
                    <strong>{firstVariation.unitPrice.toFixed(2)} €</strong>
                  </div>

                  <div className="shopping-popup__counter">
                    <button
                      type="button"
                      className={!checkMinusTen() ? "disabled" : ""}
                      onClick={
                        checkMinusTen()
                          ? fl.minusTen.bind(this, fl)
                          : undefined
                      }
                    >
                      −
                    </button>

                    <span>{amount1}</span>

                    <button
                      type="button"
                      className={!checkPlusTen() ? "disabled" : ""}
                      onClick={
                        checkPlusTen()
                          ? fl.plusTen.bind(this, fl)
                          : undefined
                      }
                    >
                      +
                    </button>
                  </div>
                </div>
              ) : null}

              {secondVariation ? (
                <div className="shopping-popup__count-item">
                  <div className="shopping-popup__pack">
                    <span>x{secondVariation.unitsInPackage}</span>
                    <strong>{secondVariation.unitPrice.toFixed(2)} €</strong>
                  </div>

                  <div className="shopping-popup__counter">
                    <button
                      type="button"
                      className={!checkMinusFifty() ? "disabled" : ""}
                      onClick={
                        checkMinusFifty()
                          ? fl.minusFifty.bind(this, fl)
                          : undefined
                      }
                    >
                      −
                    </button>

                    <span>{amount2}</span>

                    <button
                      type="button"
                      className={!checkPlusFifty() ? "disabled" : ""}
                      onClick={
                        checkPlusFifty()
                          ? fl.plusFifty.bind(this, fl)
                          : undefined
                      }
                    >
                      +
                    </button>
                  </div>
                </div>
              ) : null}
            </div>

            <button
              type="button"
              className="shopping-popup__order"
              disabled={!canOrder}
              onClick={fl.addToCart.bind(this, fl)}
            >
              {t("product.addToCart")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  cart: state.shop.cart,
  cartTemp: state.shop.cartTemp,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(shopActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCardPopup);